// extracted by mini-css-extract-plugin
export default {"App":"App_App__QMaOF","App-logo":"App_App-logo__RPlh3","App-logo-spin":"App_App-logo-spin__0i1Uk","App-header":"App_App-header__W2J3t","App-link":"App_App-link__AEgT0"};